import { RootState } from '@types';

export const selectPriceCorrections = (state: RootState) => state.priceCorrections.data;
export const selectIsPriceCorrectionAdding = (state: RootState) => state.priceCorrections.isAdding;
